module.exports = __webpack_public_path__ + "img/target_family.3f558973.svg";